import { useQuery } from '@tanstack/react-query';
import { cartQueryKey, type CartDisplay, loadCart, saveCart } from '@/api/registration/cart';
import { useTenantApi } from '@/account/hook/useTenantApi';
import { useRegistrationQuery } from '@/registration/hook/useRegistrationQuery';

export function useCartQuery(eventId: string) {
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const registrationQuery = useRegistrationQuery(eventId);
  const registration = registrationQuery?.data;
  const registrationId = registration?.id;

  return useQuery<CartDisplay, Error>({
    queryKey: [cartQueryKey, { registrationId, }],
    queryFn: async (): Promise<CartDisplay> => {
      let result = await loadCart(createTenantApiRequest)({ registrationId });
      if (result.items?.length === 0) {
        result = await saveCart(createTenantApiRequest)({ registrationId });
      }

      return result.items?.[0];
    },
    enabled: !!registrationId && !isApiPreparing,
    // cacheTime: 0,
  });
}
